module.exports = __webpack_public_path__ + "static/hamburger_close-f84e41671312ac8dd55e65fe238b66b8.svg";